import { Query } from 'redux-little-router';
import { createSelector } from 'reselect';

import { SortDirection, SortParams } from '../typings/grid';
import { State } from '../typings/state';

const MARKETERS_DEFAULT_SORT_DIRECTION = SortDirection.asc;
const MARKETERS_DEFAULT_SORT_KEY = 'login';

export const selectMarketersSortParams = createSelector(
    (state: State) => state.router.query,
    (query?: Query): SortParams | undefined => {
        if (query && query.key) {
            return {
                key: query.key,
                direction: SortDirection[query.direction] || MARKETERS_DEFAULT_SORT_DIRECTION
            };
        }
        return {
            key: MARKETERS_DEFAULT_SORT_KEY,
            direction: MARKETERS_DEFAULT_SORT_DIRECTION
        };
    }
);
